import { tk, Typography } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'

export default styled(Typography).attrs({ as: 'h1' })`
  margin-bottom: ${tk('spacing_md')};
  align-self: flex-start;

  @media ${tk('mq_tablet')} {
    margin-bottom: unset;
    ${Typography.modVariant('heading-2xl')}
  }

  ${Typography.modVariant('heading-xl')}
`
